module.exports = __webpack_public_path__ + "img/stair-down.88bd36d1.svg";